
















































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import axios from 'axios';
import { General } from '@/services/General';
import { ClaimEnum } from '@/services/ClaimEnum';

@Component
export default class ProductGenericDocumentsList extends Vue {
    @Prop({
        required: true
    })
    product: any;
    fileName: string = '';
    documentsFields = [];
    countryAuthorities: any = [];
    countryAuthoritySelected: string = null;
    genericDocumentToUpload: any = [];
    genericDocumentDescription: string = null;
    uploading: boolean = false;
    deleting: boolean = false;
    isAuthorizedUpload: boolean = false;
    showReplaceGenericDocumentChunkUploader: boolean = false;

    chunkSize: number = 300;
    importProcessList = [];
    uploadPerc: number = 0;
    idSession: string = "";

    countryAuthorityToReplace: string = null;
    genericDocumentToReplace: any = [];
    descriptionToReplace: string = null;

    general: any = {};
    selectedGenericFile: any = null;

    mounted() {
        this.reset();
        this.general = General;
        this.documentsFields = this.getDocumentFields();
        this.getCountries();
        this.isAuthorizedUpload = General.CheckAuthorization(ClaimEnum.CanUploadGenericDocument);
    }

    getDocumentFields(){
        return [
        {
            key: 'idDocument',
            label: this.$t('GENERIC.BTN_DOWNLOAD') as string,
            sortable: false,
            admin: false
        },
        {
            key: 'idDocumentEdit',
            label: this.$t('GENERIC.EDIT') as string,
            sortable: false,
            admin: true
        },
        {
            key: 'idDocumentDelete',
            label: this.$t('GENERIC.DELETE') as string,
            sortable: false,
            admin: true
        },
        {
            key: 'country',
            label: this.$t('GENERIC.REGION') as string,
            sortable: true,
            admin: false
        },
        {
            key: 'name',
            label:  this.$t('GENERIC.NAME') as string,
            sortable: true,
            admin: false
        },
        {
            key: 'description',
            label: this.$t('GENERIC.DESCRIPTION') as string,
            sortable: true,
            admin: false
        },
        {
            key: 'lastModifyDate',
            label: this.$t('PRODUCT.UPDATE_DATE') as string,
            sortable: true,
            admin: false
        }
    ]
    }
    authorizedFields() {
        if (!this.isAuthorizedUpload) return this.documentsFields.filter(this.filterFields);            
        return this.documentsFields;            
    }
    filterFields(element, index, array) {
        return (element.admin == false);
    }
    openUploadGenericFileModal() {
        this.$bvModal.show('upload-generic-document-modal');
    }
    closeUploadGenericFileModal() {
        this.$bvModal.hide('upload-generic-document-modal');
        let app = this;
        app.reset();
    }
    openReplaceGenericFileModal(genericFile: any) {
        let app = this;
        this.selectedGenericFile = genericFile;
        for (var i = 0; i < app.countryAuthorities.length; i++) {
            if (app.countryAuthorities[i].text == this.selectedGenericFile.country) {
                app.countryAuthorityToReplace = app.countryAuthorities[i].value;
            }
        }
        app.descriptionToReplace = this.selectedGenericFile.description;
        this.$bvModal.show('replace-generic-document-modal');
    }
    closeReplaceGenericFileModal() {
        let app = this;
        app.reset();
        this.$bvModal.hide('replace-generic-document-modal');
    }
    showReplaceChunkUploader() {
        this.showReplaceGenericDocumentChunkUploader = true;
    }
    askConfirmationForDeleteProduct(idDocument: string): void {
        let app = this;
        let callback = (): void => {
            app.deleteGenericDocument(idDocument);
        }
        General.confirm(this.$t('PRODUCT.CONFIRM_DELETE') as string, app, callback);
    }
    deleteGenericDocument(idDocument: string) {
        let app = this;
        app.deleting = true;
        
        axios({
            method: 'post',
            url: General.GetApiUrl('/api/document/DeleteGenericDocument?idDocument=' + idDocument),
            responseType: 'json',
            withCredentials: true
        }).then(function (response) {
            app.deleting = false;
            let documentBase = app.product.documents.filter(p => p.documentTypeCode != "GENERIC");
            app.product.documents = documentBase.concat(response.data.documents);
            
        }).catch(error => {
            app.deleting = false;
            General.HandleError(error, app);
        });
    }
    getCountries() {
        let app = this;
        let apiUrl = General.GetApiUrl('/api/culture/getcountries?emptyCountriesPolicy=0&type=COUNTRY_AUTHORITY');
        axios({
            method: 'get',
            url: apiUrl,
            responseType: 'json',
            withCredentials: true
        }).then(function (response) {
            let outputData = new Array();
            response.data.forEach(function (item: any) {
                outputData.push({
                    value: item.idCountry,
                    text: item.name
                });
            });
            app.countryAuthorities = outputData;
        }).catch(error => {
            General.HandleError(error, app);
        });
    }
    showDate(date: any): string {
        return General.showDate(date);
    }
    showSize(size: number): string {
        return General.showSize(size);
    }
    getGenericDocumentUrl(idDocument: any) {
        return General.GetApiUrl("/api/document/DownloadGenericDocumentById?documentId=" + idDocument);
    }
    getGenericDocuments(): any[] {
        let genericDocuments: any[] = [];
        for (let document of this.product.documents) {
            if (document.documentTypeCode == 'GENERIC') {
                let singleRow = {
                    name: document.documentName,
                    description: document.documentDescription,
                    country: document.culture.country.name,
                    idDocument: document.idDocument,
                    idDocumentEdit: document.idDocument,
                    idDocumentDelete: document.idDocument,
                    lastModifyDate: document.lastModifyDate,
                    documentFileSize: document.documentFileSize,
                    canBeDeleted: document.canBeDeleted
                };
               

                genericDocuments.push(singleRow);
            }
        }
        return genericDocuments;
    }
    getFileName(fileName: string) {
        console.log(fileName)
        this.fileName = fileName;
    }
    saveGenericDocument() {
        this.uploading = true;
        let app = this;
        let formData = new FormData();
        formData.append('description', app.genericDocumentDescription);
        formData.append('idproduct', app.product.idProduct);
        formData.append('idcountry', app.countryAuthoritySelected);
        formData.append('idSession', app.idSession);
        axios({
            method: 'post',
            url: General.GetApiUrl('/api/document/savegenericdocument'),
            data: formData,
            withCredentials: true
        })
            .then(function (response) {
               
                app.reset();
                if (response.data.errors) {
                    let error = "";
                    for (let i = 0; i < response.data.errors.length; i++) {
                        error += response.data.errors[i] + "<br/>";
                    }
                    General.showAlertDangerAsHTML(error, app);
                }
                else {
                    let documentBase = app.product.documents.filter(p => p.documentTypeCode != "GENERIC");                        
                    app.product.documents = documentBase.concat(response.data.documents);
                    General.showAlertSuccess(this.$t('PRODUCT.SAVE_SUCCESS'), app);
                    app.closeUploadGenericFileModal();
                }
            })
            .catch(error => {
                app.reset();
                General.HandleError(error, app);
            });
    }
    updateProgress(e: any) {
        this.uploadPerc = e;
    }
    showSuccessAlert(sessionId: any) {
        let app = this;
        app.idSession = sessionId;
        app.uploadPerc = 100;
        //General.showAlertSuccess("Upload Complete", app);
    }
    replaceGenericDocument() {
        this.uploading = true;
        let app = this;
        let formData = new FormData();
        formData.append('description', app.descriptionToReplace);
        formData.append('idproduct', app.product.idProduct);
        formData.append('idcountry', app.countryAuthorityToReplace);
        formData.append('iddocument', app.selectedGenericFile.idDocument);
        formData.append('idSession', app.idSession);
        axios({
            method: 'post',
            url: General.GetApiUrl('/api/document/replacegenericdocument'),
            data: formData,
            withCredentials: true
        })
            .then(function (response) {
                app.reset();
                if (response.data.errors) {
                    let error = "";
                    for (let i = 0; i < response.data.errors.length; i++) {
                        error += response.data.errors[i] + "<br/>";
                    }
                    General.showAlertDangerAsHTML(error, app);
                }
                else {
                    let documentBase = app.product.documents.filter(p => p.documentTypeCode != "GENERIC");
                    app.product.documents = documentBase.concat(response.data.product.documents);
                    
                    General.showAlertSuccess(this.$t('PRODUCT.UPLOAD_SUCCESS'), app);
                    app.closeReplaceGenericFileModal();
                }
            })
            .catch(error => {
                app.reset();
                General.HandleError(error, app);
            });
    }
    reset() {
        this.uploading = false;
        this.genericDocumentToUpload = [];
        this.genericDocumentDescription = "";
        this.uploadPerc = 0;
        this.showReplaceGenericDocumentChunkUploader = false;
        this.fileName = '';
        this.importProcessList = [];
        this.idSession = "";
    }
}
